
// import React from 'react';
// export function Discography() {
//   return (
//     <section className="discography py-5">
//       <div className="container">
//         <div className="row align-items-center">
//           <div className="col-md-5 position-relative">
//             <div className="blurred-bg rounded"></div>
//             <img
//               src="../img/discoPhoto.jpg" // Replace with the actual image URL
//               alt="Dina Stojilković - GRANADOS: GOYESCAS"
//               className="img-fluid rounded position-relative z-index-1 square-image"
//             />
//           </div>
//           <div className="col-md-7 text-center text-md-start">
//             <h2 className="fw-bold">Dina Stojilković</h2>
//             <h3 className="text-muted">GRANADOS: GOYESCAS</h3>
//             <div className="d-flex flex-column flex-md-row gap-3 mt-4">
//               <a
//                 href="https://linktr.ee/dinastojilkovic?utm_source=linktree_profile_share&ltsid=370ffdbb-3d39-4a1b-9233-ff71373138e5"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="btn btn-success"
//               >
//                 Listen To The Album
//               </a>
//               <a
//                 href="https://www.jpc.de/jpcng/cpo/detail/-/art/enrique-granados-goyescas/hnum/11745002"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="btn btn-secondary"
//               >
//                 Order Now
//               </a>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }





// import React from 'react';

// export function Discography() {
//   return (
//     <section className="discography py-5">
//       <div className="container">
//         <div className="row align-items-center">
//           {/* Image Section */}
//           <div className="col-md-5 position-relative">
//             <div className="blurred-bg rounded"></div>
//             <img
//               src="../img/discoPhoto.jpg" // Replace with the actual image URL
//               alt="Dina Stojilković - GRANADOS: GOYESCAS"
//               className="img-fluid rounded position-relative z-index-1 square-image"
//             />
//           </div>

//           {/* Content Section */}
//           <div className="col-md-7 text-center text-md-start">
//             <h2 className="fw-bold">Dina Stojilković</h2>
//             <h3 className="text-muted">GRANADOS: GOYESCAS</h3>

//             {/* Critics Section */}
//             <div className="critics-reviews mt-4">
//               <blockquote className="text-dark">
//                 “Admirable — the elegant fire, those songs so evocative of Chopin, the brilliance of the dances, and the depth of the melodies…An intoxicating and dizzying interpretation.”
//                 <footer className="text-muted">Artamag</footer>
//               </blockquote>

//               <blockquote className="text-dark mt-4">
//                 “I greatly enjoyed Dina Stojilković’s playing. For a start, she has all the considerable technique required…This is a most auspicious debut, and I hope to hear her again…The recording is good and the notes helpful. This is a marvelous disc.”
//                 <footer className="text-muted">MusicWeb International</footer>
//               </blockquote>

//               <blockquote className="text-dark mt-4">
//                 “Dina Stojilković, who now lives in Berlin, approaches the two books with a clear affinity for Spanish music and flawless technique. She skillfully explores the melodic roots drawn from Spanish folklore, while distinguishing between thematic material and the rich accompanying figurations… overall, a convincing interpretative performance!”
//                 <footer className="text-muted">Klassik Heute</footer>
//               </blockquote>
//             </div>

//             {/* Buttons Section */}
//             <div className="d-flex flex-column flex-md-row gap-3 mt-4 justify-content-center">
//               <a
//                 href="https://linktr.ee/dinastojilkovic?utm_source=linktree_profile_share&ltsid=370ffdbb-3d39-4a1b-9233-ff71373138e5"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="btn btn-success btn-lg"
//               >
//                 Listen To The Album
//               </a>
//               <a
//                 href="https://www.jpc.de/jpcng/cpo/detail/-/art/enrique-granados-goyescas/hnum/11745002"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="btn btn-secondary btn-lg"
//               >
//                 Order Now
//               </a>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }






import React from 'react';

export function Discography() {
  return (
    <section className="discography py-5">
      <div className="container">
        <div className="row align-items-center">
          {/* Image Section */}
          <div className="col-md-5 position-relative">
            <div className="blurred-bg rounded"></div>
            <img
              src="../img/discoPhoto.jpg" // Replace with the actual image URL
              alt="Dina Stojilković - GRANADOS: GOYESCAS"
              className="img-fluid rounded position-relative z-index-1 square-image"
            />
          </div>

          {/* Content Section */}
          <div className="col-md-7 text-center text-md-start">
            <h2 className="fw-bold">Dina Stojilković</h2>
            <h3 className="text-muted">GRANADOS: GOYESCAS</h3>

            {/* Critics Section */}
            <div className="critics-reviews mt-4">
              <h6 className="text-dark">
                “Admirable — the elegant fire, those songs so evocative of Chopin, the brilliance of the dances, and the depth of the melodies…An intoxicating and dizzying interpretation.”
                <br />
                <span className="text-muted">(Artamag)</span>
              </h6>

              <h6 className="text-dark mt-4">
                “I greatly enjoyed Dina Stojilković’s playing. For a start, she has all the considerable technique required…This is a most auspicious debut, and I hope to hear her again…The recording is good and the notes helpful. This is a marvelous disc.”
                <br />
                <span className="text-muted">(MusicWeb International)</span>
              </h6>

              <h6 className="text-dark mt-4">
                “Dina Stojilković, who now lives in Berlin, approaches the two books with a clear affinity for Spanish music and flawless technique. She skillfully explores the melodic roots drawn from Spanish folklore, while distinguishing between thematic material and the rich accompanying figurations… overall, a convincing interpretative performance!”
                <br />
                <span className="text-muted">(Klassik Heute)</span>
              </h6>
            </div>

            {/* Buttons Section */}
            <div className="d-flex flex-column flex-md-row gap-3 mt-4 justify-content-center">
              <a
                href="https://linktr.ee/dinastojilkovic?utm_source=linktree_profile_share&ltsid=370ffdbb-3d39-4a1b-9233-ff71373138e5"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-success btn-lg"
              >
                Listen To The Album
              </a>
              <a
                href="https://www.jpc.de/jpcng/cpo/detail/-/art/enrique-granados-goyescas/hnum/11745002"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-secondary btn-lg"
              >
                Order Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
